/**
 * Tilbage til siden efter et nyt login ([D-420]).
 *
 * SSO-flowet lander altid på appens forside. Kampagne-dashboardet på en
 * monitor skal kunne logges ind igen og lande på SAMME dashboard, så siden
 * husker sin adresse her lige før den sender til login, og routerens guard
 * sender tilbage efter login'et. Huskes i højst 15 minutter, så et afbrudt
 * login ikke kaprer en senere, almindelig indgang i appen.
 */

const KEY = 'cockpit:return-after-login';
const MAX_AGE_MS = 15 * 60_000;

export function rememberReturnAfterLogin(fullPath: string): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ path: fullPath, at: Date.now() }));
  } catch {
    /* privat vindue el. blokeret lager: login virker stadig, man lander blot på forsiden */
  }
}

/** Henter og sletter den huskede adresse (null når der ingen er, eller den er for gammel). */
export function consumeReturnAfterLogin(): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    localStorage.removeItem(KEY);
    const v = JSON.parse(raw) as { path?: unknown; at?: unknown };
    if (typeof v.path !== 'string' || !v.path.startsWith('/') || typeof v.at !== 'number') return null;
    if (Date.now() - v.at > MAX_AGE_MS) return null;
    return v.path;
  } catch {
    return null;
  }
}
